import "./FeedView.css";
import { useState } from "react";
import {
  Row,
  Image,
  Text,
  Spacer,
  Select,
  Button,
  Tabs,
} from "@geist-ui/react";
import { MdRssFeed, MdLocalOffer } from "react-icons/md";

import NotesView from "./NotesView/NotesView";
import PostsView from "./PostsView/PostsView";
import ConfusedImage from "../../../assets/confused.jpg";

function FeedView() {
  const [course, setCourse] = useState("");
  const [university, setUniversity] = useState("");

  return (
    <>
      <Row align="middle">
        <Select
          placeholder="Choose university"
          disableMatchWidth
          onChange={(val) => setCourse(val)}
        >
          <Select.Option value="oxford">Oxford University</Select.Option>
          <Select.Option value="vit">
            Vellore Institute of Technology
          </Select.Option>
        </Select>
        <Spacer />
        <Select
          placeholder="Choose course"
          disableMatchWidth
          onChange={(val) => setUniversity(val)}
        >
          <Select.Option value="cse3001">
            CSE3001: Operating Systems
          </Select.Option>
          <Select.Option value="cse4010">
            CSE4010: Human Computer Interaction
          </Select.Option>
        </Select>
        <Spacer />
        <Button type="secondary" size="small">
          <Text b size="medium">
            Submit
          </Text>
        </Button>
      </Row>
      <Spacer />
      <Tabs initialValue="1">
        <Tabs.Item
          label={
            <>
              <MdRssFeed />
              <Spacer x={0.3} />
              Posts
            </>
          }
          value="1"
        >
          <Spacer y={0.5} />
          {course && university && <PostsView />}
        </Tabs.Item>
        <Tabs.Item
          label={
            <>
              <MdLocalOffer />
              <Spacer x={0.3} />
              Notes
            </>
          }
          value="2"
        >
          <Spacer y={0.5} />
          {course && university && <NotesView />}
        </Tabs.Item>
      </Tabs>
      {(!course || !university) && (
        <Image src={ConfusedImage} height="20vh" className="image" />
      )}
    </>
  );
}

export default FeedView;
